import TeamInvitesTable from './TeamInvitesTable'

export default TeamInvitesTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/TeamInvitesTable/index.js